export enum EKiwidPlanStatus {
    CREATED = 0,
    PENDING = 1,
    ACTIVE = 2,
    BLOCKED = 3,
    INACTIVE = 4,
    WAITING = 5
}

export enum EKiwidPlanActiveStatusType {
    TRIAL = 1,
    ACTIVE = 2,
    PAYMENT = 3
}

export enum EKiwidPlanInactiveStatusType {
    TRIAL_ENDED = 1,
    DEBTOR = 2,
    CHANGE = 3,
    CHURN_MANUAL = 4,
    CHURN_AUTO = 5
}

export enum EKiwidPlanItemStatus {
    ACTIVE = 1,
    WAITING = 2,
    INACTIVE = 3
}

export enum EKiwidPlanItemActiveStatusType {
    ACTIVE = 1,
    WAITING_CHANGE = 2,
    WAITING_CANCEL = 3,
    FREE = 4
}

